module.exports = __webpack_public_path__ + "static/media/nav.d779b134.svg";